const QUANTITY_DEFAULT_VALUE = 1;
const QUANTITY_MIN_VALUE = 0.01;
const QUANTITY_MAX_VALUE = 30;
const QUANTITY_DECIMAL_PLACES = 3;

export const getQuantityMinValue = (): number => {
   return QUANTITY_MIN_VALUE;
};

export const getQuantityMaxValue = (): number => {
   return QUANTITY_MAX_VALUE;
};

export const getQuantityPrecision = (): number => {
   return QUANTITY_DECIMAL_PLACES;
};

export const getQuantityDefaultValue = (): number => {
   return QUANTITY_DEFAULT_VALUE;
};
